module.exports = __webpack_public_path__ + "static/media/loading_object.9c3368d9.png";